<template>
  <base-section id="video">
    <v-container>
      <base-section-heading
        title="Gallery"
        color="secondary"
        align="left"
        :toColor="true"
      >
        Closing video from LATS 2027.
      </base-section-heading>

      <v-row>
        <v-col cols="12">
          <div class="video-wrapper">
            <video
              :src="videoUrl"
              controls
              preload="metadata"
              playsinline
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </v-col>
      </v-row>

      <!---
      <v-row>
        <v-col cols="12" md="10" lg="8">
          <p class="text-body-1 mb-0">
            The closing video is loaded from
            <strong>/public/CLOSING_LATS27.mp4</strong>.
            You can add photo cards below this block later.
          </p>
        </v-col>
      </v-row>
      --->
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Video',

    data: () => ({
      videoUrl: 'CLOSING_LATS27.mp4',
    }),
  }
</script>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.video-wrapper video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
